// Shared config for the marketing site's events feature. Consumed by
// pages/Events.js (grid), pages/EventDetail.js (per-event page), and
// pages/Home.js (upcoming section). Keeping this in one place avoids
// three copies of the category → icon map drifting apart.

import { BookOpen, HeartHandshake, Leaf, Gift, Globe, Flame, Cake, GraduationCap, Users } from 'lucide-react';
import worshipBg from '../assets/images/worship_bg.jpg';
import prayer2 from '../assets/images/prayer2.jpg';
import ministrytile from '../assets/images/ministrytile.jpg';
import prayerBg from '../assets/images/prayer_bg.jpg';
import bibleStudyBg from '../assets/images/bible_study_bg.jpg';

export const EVENTS_FEED_URL = 'https://eventsfeed-jw6bkm54ga-ue.a.run.app';
// Routed through the Firebase Hosting rewrite defined in firebase.json.
// The organization has a Domain Restricted Sharing policy that blocks
// allUsers-invoker bindings on Cloud Run, so we can't call the function
// directly from an unauthenticated browser. Hosting rewrites use an
// internal service account that IS allowed, so this path works while
// keeping the function private at the Cloud Run layer.
export const RSVP_URL = 'https://app.brightlightbaptist.church/api/rsvpEvent';

// Presets mirror lib/features/admin/presentation/pages/admin_events_page.dart.
// Custom / unknown categories fall back to CATEGORY_META.worship at lookup.
export const CATEGORY_META = {
  worship: { Icon: BookOpen, fallback: worshipBg },
  outreach: { Icon: HeartHandshake, fallback: prayerBg },
  youth: { Icon: Globe, fallback: bibleStudyBg },
  women: { Icon: HeartHandshake, fallback: prayer2 },
  men: { Icon: HeartHandshake, fallback: prayer2 },
  community: { Icon: Leaf, fallback: ministrytile },
  special: { Icon: Gift, fallback: prayerBg },
  revival: { Icon: Flame, fallback: worshipBg },
  celebration: { Icon: Cake, fallback: prayerBg },
  class: { Icon: GraduationCap, fallback: bibleStudyBg },
  marriage: { Icon: Users, fallback: prayer2 },
};

export function decorateEvent(event) {
  const meta = CATEGORY_META[event.category] || CATEGORY_META.worship;
  return {
    ...event,
    Icon: meta.Icon,
    imageUrl: event.imageUrl || meta.fallback,
    // Server-side flag "recurring" is rarely set; infer from dateLabel.
    recurring: event.recurring ?? /every|weekly|sundays|wednesdays/i.test(event.dateLabel || ''),
  };
}
